import { formatActivityDateAndTimes } from "web_myplann/Activities/Utils/formatActivityDateAndTimes";
import type { ActivityDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const useFormatDateAndTimes = () => formatActivityDateAndTimes;

export const useFormatDateTimeByClientActivity = () => {
	const formatDateAndTimes = useFormatDateAndTimes();

	return (dataEvent: ActivityDetailResponseDTO) => {
		return formatDateAndTimes(
			dataEvent?.date,
			dataEvent?.timeFrom,
			dataEvent?.timeTo,
		);
	};
};
